<div class="driver-success-model">
    <img [src]="isSpotUpdate ? '../../../../assets/images/driver-success.png' : '../../../../assets/images/failed-icon.svg'" alt="" />
    <h4 [ngClass]="{ 'payment-failed': !isSpotUpdate }"> {{heading ? heading:'Success!'}}</h4>
    <p [innerHTML]="bodyText"></p>
    <div class="btn-outer">
        <p-button  label="OK" (onClick)="navigateToBookingDetailsScreen()"/>
    </div>
</div>
